import { render, staticRenderFns } from "./mobile-footer-nav.vue?vue&type=template&id=29809c68&scoped=true&"
import script from "./mobile-footer-nav.vue?vue&type=script&lang=ts&"
export * from "./mobile-footer-nav.vue?vue&type=script&lang=ts&"
import style0 from "./mobile-footer-nav.vue?vue&type=style&index=0&id=29809c68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29809c68",
  null
  
)

export default component.exports